"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.theme = void 0;
const custom_1 = require("./custom");
exports.theme = custom_1.createThemeFromColor('#111111', 'dark-black', 'Đen sẫm');
//# sourceMappingURL=dark-black.js.map